import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../utils/api';

// The organisation's own profile: name and the short name used in its
// sign-in link. Any administrator may change both.

interface DataEnvelope<T> {
  data: T;
}

export interface TenantProfile {
  name: string;
  /** Short name used in the sign-in link, e.g. "acme-council". */
  slug: string;
  /** App-relative sign-in link, e.g. "/login/acme-council". */
  login_path: string;
  can_edit: boolean;
}

export interface TenantProfileInput {
  name?: string;
  slug?: string;
}

export const TENANT_PROFILE_KEY = ['tenant-profile'];

export const useTenantProfile = () =>
  useQuery({
    queryKey: TENANT_PROFILE_KEY,
    queryFn: async () => {
      const res = await api.request<DataEnvelope<TenantProfile>>('/api/admin/tenant/profile');
      return res.data;
    },
  });

export const useUpdateTenantProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: TenantProfileInput) => {
      const res = await api.request<DataEnvelope<TenantProfile>>('/api/admin/tenant/profile', {
        method: 'PATCH',
        body,
      });
      return res.data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(TENANT_PROFILE_KEY, data);
      // The sign-in page shows the link and Organisations shows the slug.
      queryClient.invalidateQueries({ queryKey: ['sso-setting'] });
      queryClient.invalidateQueries({ queryKey: ['tenants'] });
    },
  });
};
